import 'babel-polyfill'
import browserDetect from "vue-browser-detect-plugin";
import axios from 'axios'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.api = "https://www.kmppartners.info:1135/api-contract"
// Vue.prototype.api = "http://192.168.10.25:1135/api-contract"
Vue.prototype.version = "KMP Partners Contract Document 64.03.05.02"
Vue.use(browserDetect);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
